import {isFilled} from '@prismicio/client'
import type {HubSpotFormSliceMultipleForms} from 'prismicio-types'
import {useEffect, useState} from 'react'
import {EVENTS, track} from 'src/common/helpers'
import {useCreateHubspotForm} from 'src/common/hooks'

type HubspotMultipleFormsVariationProps = {
  slice: HubSpotFormSliceMultipleForms
  pageUid: string
  componentIndex: number
}

export const MultipleFormsVariation = ({slice, pageUid, componentIndex}: HubspotMultipleFormsVariationProps) => {
  const [selectedFormId, setSelectedFormId] = useState<string | null>(null)

  const {
    primary: {forms},
  } = slice

  useCreateHubspotForm({
    region: 'eu1',
    portalId: slice.primary.portal_id!,
    formId: selectedFormId || '',
    target: '#hubspot-form-wrapper',
    onFormSubmit: () => {
      track({
        location: `component-${componentIndex}-hubspot-form`,
        dataType: slice.primary.form_type!,
        event: EVENTS.FORM_SUBMIT,
        mktgId: 'form-submission-button',
        pageName: pageUid,
      })
    },
  })

  // Select form id depending on UTM parameter
  useEffect(() => {
    if (typeof window === 'undefined' || !isFilled.group(forms)) {
      return
    }

    const urlParams = new URLSearchParams(window.location.search)
    const utmCampaign = urlParams.get('utm_campaign')
    const matchedForm = forms.find((form) => form.utm_campaign_value === utmCampaign)
    const defaultForm = forms.find((form) => form.utm_campaign_value === 'default')

    if (matchedForm) {
      setSelectedFormId(matchedForm.form_id)
    } else if (defaultForm) {
      setSelectedFormId(defaultForm.form_id)
    }
  }, [forms])

  return <div className={slice.primary.container_css_classes + ' md:!pt-[112px]' || ''} id="hubspot-form-wrapper" />
}
